var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_13382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.375 12C12.1674 12 13.625 10.5424 13.625 8.75C13.625 6.95762 12.1674 5.5 10.375 5.5C8.58262 5.5 7.125 6.95762 7.125 8.75C7.125 10.5424 8.58262 12 10.375 12ZM10.375 6.04167C11.8684 6.04167 13.0833 7.25662 13.0833 8.75C13.0833 10.2434 11.8684 11.4583 10.375 11.4583C8.88162 11.4583 7.66667 10.2434 7.66667 8.75C7.66667 7.25662 8.88162 6.04167 10.375 6.04167ZM11.3625 14.7495C11.4768 14.8465 11.4908 15.0171 11.3944 15.1314L11.1333 15.4401C10.7552 15.8865 9.99529 15.8865 9.61721 15.4401L8.46129 14.074C8.27279 13.8503 7.94183 13.8211 7.70621 14.0042C6.64833 14.8318 6.04167 16.0755 6.04167 17.4167V18.2292C6.04167 18.3787 5.92033 18.5 5.77083 18.5C5.62133 18.5 5.5 18.3787 5.5 18.2292V17.4167C5.5 15.9081 6.1825 14.509 7.37254 13.5779C7.83729 13.2128 8.49758 13.2778 8.87458 13.7241L10.0305 15.0902C10.2017 15.2933 10.5478 15.2933 10.719 15.0902L10.98 14.7815C11.077 14.6683 11.2482 14.6536 11.3625 14.7495Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 2.75,
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4462 14.1939C15.3595 14.1939 15.2862 14.1639 15.2262 14.1039C15.1662 14.0439 15.1362 13.9706 15.1362 13.8839C15.1362 13.7972 15.1662 13.7239 15.2262 13.6639C15.2862 13.6039 15.3595 13.5739 15.4462 13.5739C15.5295 13.5739 15.5995 13.6039 15.6562 13.6639C15.7162 13.7239 15.7462 13.7972 15.7462 13.8839C15.7462 13.9706 15.7162 14.0439 15.6562 14.1039C15.5995 14.1639 15.5295 14.1939 15.4462 14.1939ZM15.6662 14.6389V17.3789H15.2112V14.6389H15.6662Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_13382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "currentColor",
    transform: "translate(5.5 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.8f8a4a65b819ff4f3ea936aed3574bdf.svg";
export { ForwardRef as ReactComponent };